import * as authRequests from './requests/auth/auth.requests';
import * as clientRequests from './requests/client/client.requests';
import * as dashboardRequests from './requests/dashboard/dashboard.requests';
import * as orderRequests from './requests/order/order.requests';
import * as planRequests from './requests/plan/plan.requests';
import * as reportsRequests from './requests/reports/reports.requests';
import * as simRequests from './requests/sim/sim.requests';
import * as userRequests from './requests/user/user.requests';

const iotApi = {
  auth: authRequests,
  sim: simRequests,
  dashboard: dashboardRequests,
  user: userRequests,
  client: clientRequests,
  plan: planRequests,
  order: orderRequests,
  reports: reportsRequests,
};

export default iotApi;
